/**
 * @require ../pdf-designer.window.js
 */
(function (global) {
    if (!global.Model) {
        global.Model = {};
    }

    /**
     * @augments {BaseComponent}
     * @typedef TextComponent
     */
    global.Model.TextComponent = (function () {
        /**
         * @param {string|null} title
         * @param {string|null} description
         * @param {ComponentOptions} options
         * @constructor
         */
        function TextComponent(title, description, options) {
            const defaultFont = options.Fonts.indexOf('Helvetica') >= 0 ? 'Helvetica' : 'Arial';

            this.ComponentSettings = [
                {
                    Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.label'),
                    Settings: [
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.textLabel.label'),
                            Key: 'Textflow.Text',
                            Type: global.Model.Enums.ComponentSettingRepresentation.MultiLineInput,
                            SubType: 'text'
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.font.label'),
                            Key: 'Textflow.Font',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Dropdown,
                            Options: options.Fonts.map(font => { return { Label: font, Value: font }; }),
                            Default: defaultFont
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.color.label'),
                            Key: 'Textflow.Color',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Color,
                            Default: '#000'
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.size.label'),
                            Key: 'Textflow.FontSize',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Input,
                            SubType: 'number',
                            Min: 0,
                            Max: 100
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.style.label'),
                            Key: 'Textflow',
                            AllowMultiSelection: true,
                            Type: global.Model.Enums.ComponentSettingRepresentation.MultiButtonSelection,
                            Options: [
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.style.bold'),
                                    Icon: './img/bold-solid.svg',
                                    Key: 'Bold'
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.style.italic'),
                                    Icon: './img/italic-solid.svg',
                                    Key: 'Italic'
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.style.underline'),
                                    Icon: './img/underline-solid.svg',
                                    Key: 'Underline'
                                }
                            ]
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.dynamicFontSize.label'),
                            Key: 'Textflow.IsFontsizeDynamic',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Boolean
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.maxCharactersCount.label'),
                            Key: 'Textflow.MaxCharacters',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Input,
                            SubType: 'number',
                            Min: 0
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.maxLines.label'),
                            Key: 'Textflow.MaxLines',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Input,
                            SubType: 'number',
                            Min: 0
                        }
                    ]
                },
                {
                    Label: i18next.t('changeMode.pdfDesigner.settings.layout.label'),
                    Settings: [
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.label'),
                            Key: 'Layout.HorizontalAlignment',
                            Type: global.Model.Enums.ComponentSettingRepresentation.MultiButtonSelection,
                            Options: [
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.left'),
                                    Icon: './img/align-left-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Left
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.center'),
                                    Icon: './img/align-center-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Center
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.right'),
                                    Icon: './img/align-right-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Right
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.justify'),
                                    Icon: './img/align-justify-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Justify
                                }
                            ]
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.label'),
                            Key: 'Layout.VerticalAlignment',
                            Type: global.Model.Enums.ComponentSettingRepresentation.MultiButtonSelection,
                            Options: [
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.top'),
                                    Icon: './img/vertical-align-top.svg',
                                    IconStyle: 'width:100%;',
                                    Value: global.Model.Enums.VerticalAlignment.Top
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.center'),
                                    Icon: './img/vertical-align-center.svg',
                                    IconStyle: 'width:100%;',
                                    Value: global.Model.Enums.VerticalAlignment.Center
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.bottom'),
                                    Icon: './img/vertical-align-bottom.svg',
                                    IconStyle: 'width:100%;',
                                    Value: global.Model.Enums.VerticalAlignment.Bottom
                                }
                            ]
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.layout.rotation.label'),
                            Key: 'Layout.Rotation',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Input,
                            SubType: 'number',
                            Min: -360,
                            Max: 360,
                            Default: 0
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.layout.bottomBorder.label'),
                            Key: 'Underline',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Boolean
                        }
                    ]
                }
            ];

            global.Model.BaseComponent.call(
                this,
                global.Model.Enums.ComponentType.Text,
                title,
                description,
                'font-solid.svg',
                options
            );
        }

        TextComponent.prototype = Object.create(global.Model.BaseComponent.prototype);

        TextComponent.prototype.CreateDerivedInstance = function (relativeX, relativeY) {
            const $deferred = $.Deferred();
            const additionalSettings = {
                Textflow: {
                    Text: this.Title,
                    FontSize: .95
                },
                Layout: {
                    HorizontalAlignment: global.Model.Enums.HorizontalAlignment.Left,
                    VerticalAlignment: global.Model.Enums.VerticalAlignment.Top
                }
            };

            global.Model.BaseComponent.prototype.CreateDerivedInstance.call(
                this,
                relativeX,
                relativeY,
                additionalSettings
            ).then(component => $deferred.resolve(component));

            return $deferred.promise();
        };

        /**
         * @return {string}
         */
        TextComponent.prototype.CreateComponentContent = function () {
            const markup = ['<span'];
            const styles = [];

            if (!!this.Textflow && !!this.Textflow.Color) {
                styles.push(`color:${this.Textflow.Color}`);
            }

            if (typeof this.Layout.Rotation === 'number' && !isNaN(this.Layout.Rotation)) {
                styles.push(`transform:rotate(${this.Layout.Rotation}deg)`);
            }

            if (styles.length) {
                markup.push(` style="${styles.join(';')}"`);
            }

            markup.push(`>${DOMPurify.sanitize(this.Textflow.Text).replace(/\r?\n|\r/g, '<br />')}</span>`);

            return markup.join('');
        };

        TextComponent.prototype.constructor = TextComponent;

        return TextComponent;
    })();

    /**
     * @augments {BaseComponent}
     * @typedef CataloguePictureComponent
     */
    global.Model.CataloguePictureComponent = (function () {
        /**
         * @param {string|null} title
         * @param {string|null} description
         * @param {ComponentOptions} options
         * @constructor
         */
        function CataloguePictureComponent(title, description, options) {
            this.ComponentSettings = [
                {
                    Label: i18next.t('changeMode.pdfDesigner.settings.files.image'),
                    Settings: [
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.files.fileSelection.label'),
                            Key: 'FileOID',
                            Type: global.Model.Enums.ComponentSettingRepresentation.FileSelection,
                            SubType: 'image'
                        }
                    ]
                },
                {
                    Label: i18next.t('changeMode.pdfDesigner.settings.layout.label'),
                    Settings: [
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.label'),
                            Key: 'Layout.HorizontalAlignment',
                            Type: global.Model.Enums.ComponentSettingRepresentation.MultiButtonSelection,
                            Options: [
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.left'),
                                    Icon: './img/align-left-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Left
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.center'),
                                    Icon: './img/align-center-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Center
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.horizontalAlignment.right'),
                                    Icon: './img/align-right-solid.svg',
                                    Value: global.Model.Enums.HorizontalAlignment.Right
                                }
                            ]
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.label'),
                            Key: 'Layout.VerticalAlignment',
                            Type: global.Model.Enums.ComponentSettingRepresentation.MultiButtonSelection,
                            Options: [
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.top'),
                                    Icon: './img/vertical-align-top.svg',
                                    IconStyle: 'width:100%;',
                                    Value: global.Model.Enums.VerticalAlignment.Top
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.center'),
                                    Icon: './img/vertical-align-center.svg',
                                    IconStyle: 'width:100%;',
                                    Value: global.Model.Enums.VerticalAlignment.Center
                                },
                                {
                                    Caption: i18next.t('changeMode.pdfDesigner.settings.textFlow.verticalAlignment.bottom'),
                                    Icon: './img/vertical-align-bottom.svg',
                                    IconStyle: 'width:100%;',
                                    Value: global.Model.Enums.VerticalAlignment.Bottom
                                }
                            ]
                        },
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.layout.rotation.label'),
                            Key: 'Layout.Rotation',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Input,
                            SubType: 'number',
                            Min: -360,
                            Max: 360,
                            Default: 0
                        }
                    ]
                }
            ];

            global.Model.BaseComponent.call(
                this,
                global.Model.Enums.ComponentType.Image,
                title,
                description,
                'image-regular.svg',
                options
            );

            this.DefaultDimensions = {
                Width: 30,
                Height: 22
            };
        }

        CataloguePictureComponent.prototype = Object.create(global.Model.BaseComponent.prototype);
        CataloguePictureComponent.prototype.constructor = CataloguePictureComponent;

        CataloguePictureComponent.prototype.CreateDerivedInstance = function (relativeX, relativeY) {
            const $deferred = $.Deferred();
            const additionalSettings = {
                Layout: {
                    HorizontalAlignment: global.Model.Enums.HorizontalAlignment.Center,
                    VerticalAlignment: global.Model.Enums.VerticalAlignment.Center
                }
            };

            global.Model.BaseComponent.prototype.CreateDerivedInstance.call(
                this,
                relativeX,
                relativeY,
                additionalSettings
            ).then(component => $deferred.resolve(component));

            return $deferred.promise();
        };

        CataloguePictureComponent.prototype.CreateComponentContent = function () {
            const file = !!this.FileOID ? changemode.Files[this.FileOID] : null;
            const filePath = file ? `${Config.BaseUri}images/s/${file.Filename}` : './img/image-regular.svg';

            const styles = [];

            if (typeof this.Layout.Rotation === 'number' && !isNaN(this.Layout.Rotation)) {
                styles.push(`transform:rotate(${this.Layout.Rotation}deg)`);
            }

            return `<img src="${filePath}" style="max-height:100%;max-width:100%;${styles.length ? styles.join(';') : ''}" />`;
        };

        return CataloguePictureComponent;
    })();

    /**
     * @augments {BaseComponent}
     * @typedef TableComponent
     */
    global.Model.TableComponent = (function () {
        /**
         * @typedef TableElementBorder
         * @property {string} Color Rahmenfarbe (Hex)
         * @property {number} Width Rahmenbreite
         * @property {bool} Dashed true: zeichnet den Rahmen als gestrichelte Linie, ansonsten durchgehend
         */

        /**
         * @typedef TableCell
         * @property {number} RowSpan
         * @property {number} [Row]
         * @property {number} Column
         * @property {number} ColumnSpan
         * @property {number} Width
         * @property {number} Height
         * @property {string} BackgroundColor
         * @property {string} OID
         * @property {BaseComponent[]} Content
         * @property {boolean} IsTemplate True, wenn es sich um eine Teilprobe handelt
         * @property {boolean} IsHeader True, wenn es sich um eine Header-Zelle handelt
         * @function CreateCellMarkup
         */

        /**
         * @typedef CellSettings
         * @property {number} [RowSpan]
         * @property {number} [Row]
         * @property {number} [Column]
         * @property {number} [ColumnSpan]
         * @property {number} [Width]
         * @property {number} [Height]
         * @property {string} [BackgroundColor]
         * @property {BaseComponent[]} [Content]
         * @property {boolean} [IsTemplate] True, wenn es sich um eine Teilprobe handelt
         * @property {boolean} [IsHeader] True, wenn es sich um eine Header-Zelle handelt
         */

        /**
         * @typedef TableCellProvider
         * @property {number} Type Absolut oder Teilprobe
         * @property {TableCell[][]} [Cells] Muss gefüllt werden, wenn statische Daten hinterlegt werden sollen
         */


        /**
         * @typedef AbsoluteCellProvider
         * @property {number} Type Absolut
         * @property {TableCell[][]} Cells Muss gefüllt werden, wenn statische Daten hinterlegt werden sollen
         */

        /**
         * @typedef SubsampleParameterCellProvider
         * @property {number} Type Teilprobe
         * @property {TableCell[][]} [Cells] Muss gefüllt werden, wenn statische Daten hinterlegt werden sollen
         * @property {string} [ParameterGroupOID] Wird benötigt, wenn es sich um eine Teilprobengruppe handelt
         * @property {TableCell[]} TemplateCells Wird benötigt, wenn es sich um eine Teilprobengruppe handelt
         */


        /**
         * @param {string} title
         * @param {string} description
         * @param {ComponentOptions} options
         * @constructor
         */
        function TableComponent(title, description, options) {
            global.Model.BaseComponent.call(
                this,
                global.Model.Enums.ComponentType.Table,
                title,
                description,
                'table-solid.svg',
                options
            );

            this.DefaultDimensions = {
                Width: 40,
                Height: 7.5
            };

            this.Layout.HorizontalAlignment = global.Model.Enums.HorizontalAlignment.Left;
            this.Layout.VerticalAlignment = global.Model.Enums.HorizontalAlignment.Top;

            /**
             * @type {Object.<number, TableElementBorder>}
             */
            this.RowBorders = options.RowBorders || {};

            /**
             * @type {Object.<number, TableElementBorder>}
             */
            this.ColumnBorders = options.ColumnBorders || {};

            /**
             * @type {AbsoluteCellProvider}
             */
            this.HeaderCellProvider = options.HeaderCellProvider || {
                Type: global.Model.Enums.TableCellProviderType.Absolute,
                Cells: []
            };

            /**
             * @type {TableCellProvider | AbsoluteCellProvider | SubsampleParameterCellProvider}
             */
            this.CellProvider = options.CellProvider || {
                Type: global.Model.Enums.TableCellProviderType.Absolute,
                Cells: []
            };

            /**
             * @type {Object.<string, BaseComponent>}
             */
            this.TableComponentsMap = {};

            /**
             * @type {Object.<string, TableCell>}
             */
            this.TableCellsMap = {};
            this.ColumnSizes = [];

            this.ZIndex = 2;
        }

        TableComponent.prototype = Object.create(global.Model.BaseComponent.prototype);

        TableComponent.prototype.constructor = TableComponent;

        TableComponent.prototype.CreateDerivedInstance = function (relativeX, relativeY) {
            const $deferred = $.Deferred();

            global.Model.BaseComponent.prototype.CreateDerivedInstance.call(
                this,
                relativeX,
                relativeY
            ).then((component) => {
                component.IsSubsampleTable = !!this.IsSubsampleTable;
                $deferred.resolve(component);
            });

            return $deferred.promise();
        };

        /**
         * Erstellt/Initialisiert eine Teilproben-Tabelle.
         * @function SetNewSubsampleTableContent
         * @param {string} groupOID OID der Teilprobe
         * @param {BaseComponent} subsampleCheckpointComponent Komponente von dem Teilproben-Prüfpunkt
         */
        TableComponent.prototype.SetNewSubsampleTableContent = function(groupOID, subsampleCheckpointComponent) {
            delete this.CellProvider.Cells;
            this.IsSubsampleTable = true;
            this.GroupOID = groupOID;
            this.CellProvider.Type = global.Model.Enums.TableCellProviderType.Subsample;
            this.CellProvider.ParameterGroupOID = groupOID;
            this.CellProvider.TemplateCells = [];

            this.CellProvider.TemplateCells.push(
                this.CreateTableCell({
                    Row: 0,
                    Column: 0,
                    IsTemplate: true,
                    Content: [subsampleCheckpointComponent]
                })
            );

            for (let i = 0; i < this.HeaderCellProvider.Cells.length; i++) {
                const row = this.HeaderCellProvider.Cells[i];

                // Bei 1 anfangen, da die neue Komponente schon drin ist
                for (let j = 1; j < row.length; j++) {
                    this.CellProvider.TemplateCells.push(
                        this.CreateTableCell({
                            Row: 0,
                            Column: j,
                            IsTemplate: true,
                            Content: []
                        }));
                }
            }
        };

        TableComponent.prototype.CreateComponentContent = function () {
            const markup = [
                '<div class="table-settings-button"><img class="cog-icon" src="./img/menu/cog.svg" width="15px" height="15px"></div>',
                '<table>',
                '<thead>',
            ];

            if (this.HeaderCellProvider.Cells.length === 0) {
                // leere 1x1 Tabelle mit Textzeilen erstellen
                const headerCell = this.CreateTableCell({Width: this.Width ,Row: 0, Column: 0, IsTemplate: !!this.IsSubsampleTable, IsHeader: true});

                this.HeaderCellProvider.Cells.push(
                    [headerCell]
                );
            }

            for (let i = 0; i < this.HeaderCellProvider.Cells.length; i++) {
                const row = this.HeaderCellProvider.Cells[i];
                let rowHeight = 0;
                const cellsMarkup = [];

                for (let j = 0; j < row.length; j++) {
                    const cell = row[j];
                    const tableCell = this.CreateTableCell({
                        Row: i,
                        RowSpan: cell.RowSpan,
                        Column: j,
                        ColumnSpan: cell.ColumnSpan,
                        IsTemplate: this.IsSubsampleTable || cell.IsTemplate,
                        IsHeader: true,
                        BackgroundColor: cell.BackgroundColor || '#cccccc',
                        Width: cell.Width,
                        Height: cell.Height,
                        Content: cell.Content
                    });

                    cellsMarkup.push(tableCell.CreateCellMarkup(this.Page));

                    this.SetTableCell(tableCell, true);

                    rowHeight = Math.max(rowHeight, (tableCell.Height / 100) * this.Page.Height);
                }

                markup.push(`<tr style="height:${rowHeight}px;">${cellsMarkup.join('')}</tr>`);
            }

            markup.push('</thead>');
            markup.push('<tbody>');

            if (this.CellProvider.Type === global.Model.Enums.TableCellProviderType.Subsample) {
                let rowHeight = 0;
                const cellsMarkup = [];

                for (let i = 0; i < this.CellProvider.TemplateCells.length; i++) {
                    const cell = this.CellProvider.TemplateCells[i];
                    const tableCell = this.CreateTableCell({
                        Row: 0,
                        Column: i,
                        ColumnSpan: cell.ColumnSpan,
                        IsTemplate: true,
                        IsHeader: false,
                        BackgroundColor: cell.BackgroundColor || '#ffffff',
                        Width: cell.Width,
                        Height: cell.Height,
                        Content: cell.Content
                    });

                    cellsMarkup.push(tableCell.CreateCellMarkup(this.Page));

                    this.SetTableCell(tableCell, false);

                    rowHeight = Math.max(rowHeight, (tableCell.Height / 100) * this.Page.Height);
                }

                markup.push(`<tr style="height:${rowHeight}px;">${cellsMarkup.join('')}</tr>`);
            } else {
                if (this.CellProvider.Cells.length === 0) {
                    const contentCell = this.CreateTableCell({Width: this.Width, Row: 0, Column: 0, IsTemplate: false, IsHeader: false});

                    this.CellProvider.Cells.push(
                        [contentCell]
                    );
                }

                for (let i = 0; i < this.CellProvider.Cells.length; i++) {
                    const row = this.CellProvider.Cells[i];
                    let rowHeight = 0;
                    const cellsMarkup = [];

                    for (let j = 0; j < row.length; j++) {
                        const cell = row[j];
                        const tableCell = this.CreateTableCell({
                            Row: i,
                            RowSpan: cell.RowSpan,
                            Column: j,
                            ColumnSpan: cell.ColumnSpan,
                            IsTemplate: cell.IsTemplate,
                            IsHeader: false,
                            BackgroundColor: cell.BackgroundColor || '#ffffff',
                            Width: cell.Width,
                            Height: cell.Height,
                            Content: cell.Content
                        });

                        cellsMarkup.push(tableCell.CreateCellMarkup(this.Page));

                        this.SetTableCell(tableCell, false);

                        rowHeight = Math.max(rowHeight, (tableCell.Height / 100) * this.Page.Height);
                    }

                    markup.push(`<tr style="height:${rowHeight}px;">${cellsMarkup.join('')}</tr>`);
                }
            }

            markup.push('</tbody>', '</table>');

            return markup.join('');
        };

        /**
         * Erstellt eine neue Instaz für eine Tabellenzelle.
         * Wenn eine neue Tabelle erstellt wird oder wenn der Content der Zelle leer ist, wird ein Platzhalter (Text-Komponente) erstellt.
         * @function
         * @param {CellSettings} cellSettings - Einstellungen von der Zelle
         * @returns {TableCell} Tabellenzelle
         */
        TableComponent.prototype.CreateTableCell = function (cellSettings) {
            const cell = new this.TableCell({
                Row: cellSettings.Row,
                RowSpan: cellSettings.RowSpan,
                Column: cellSettings.Column,
                ColumnSpan: cellSettings.ColumnSpan,
                IsTemplate: cellSettings.IsTemplate,
                IsHeader: cellSettings.IsHeader,
                BackgroundColor: cellSettings.BackgroundColor,
                Width: cellSettings.Width,
                Height: cellSettings.Height,
                Content: cellSettings.Content
            });

            if (cell.IsTemplate) {
                this.IsSubsampleTable = true;
            }

            if ((cellSettings.Content || []).length === 0) {
                const textComponent = new global.Model.TextComponent(
                    i18next.t('changeMode.pdfDesigner.components.static.textField.placeholder'),
                    null,
                    {
                        Fonts: [],
                        OID: uuid(),
                        IsTableCell: true
                    });

                textComponent.Textflow = { Text: i18next.t('changeMode.pdfDesigner.components.static.textField.placeholder'), FontSize: 0.95 };
                textComponent.Layout = {
                    HorizontalAlignment: global.Model.Enums.HorizontalAlignment.Left,
                    VerticalAlignment: global.Model.Enums.VerticalAlignment.Center,
                    Rotation: 0,
                    Fitmethod: global.Model.Enums.FitMethod.Auto
                };
                textComponent.Position = { Type: global.Model.Enums.PositionType.Relative, Coordinates: { X: 0, Y: 0 } };
                textComponent.SetPage(this.Page);
                textComponent.RenderArea = global.Model.Enums.SectionModificationArea.Page;

                const relativeCoordinates = {
                    left: 0,
                    top: 0
                };

                const relativeDimensions = {
                    height: cell.Height || 2.5,
                    width: cell.Width || 4
                };

                textComponent
                    .SetCoordinates(relativeCoordinates.left, relativeCoordinates.top)
                    .SetDimensions(relativeDimensions.height, relativeDimensions.width);

                textComponent.CellOID = cell.OID;
                textComponent.IsTableCell = true;
                textComponent.TableIdentifier = this.OID;
                cell.Content = [textComponent];
                cell.Width = textComponent.Width;
                cell.Height = textComponent.Height;

                this.TableComponentsMap[textComponent.OID] = textComponent;
            } else {
                cell.Content = cellSettings.Content || [];

                for (let i = 0; i < cell.Content.length; i++) {
                    const component = cell.Content[i];

                    component.Position = { Type: global.Model.Enums.PositionType.Relative, Coordinates: { X: 0, Y: 0 } };
                    component.SetPage(this.Page);
                    component.RenderArea = global.Model.Enums.SectionModificationArea.Page;
                    component.CellOID = cell.OID;
                    component.IsTableCell = true;
                    component.TableIdentifier = this.OID;

                    const relativeDimensions = {
                        height: cell.Height || component.Height || 0,
                        width: cell.Width || component.Width || 0
                    };

                    component
                        .SetDimensions(relativeDimensions.height, relativeDimensions.width);

                    this.TableComponentsMap[component.OID] = component;
                }

                cell.Height = cell.Content.reduce((acc, value) => acc + value.Height, 0);
            }

            return cell;
        };

        /**
         * Speichert die Änderungen einer Zelle
         * @param {TableCell} tableCell
         * @param {boolean} isHeader
         */
        TableComponent.prototype.SetTableCell = function(tableCell, isHeader) {
            const row = tableCell.Row;
            const column = tableCell.Column;

            this.TableCellsMap[tableCell.OID] = tableCell;

            if (isHeader) {
                this.HeaderCellProvider.Cells[row || 0][column] = tableCell;

                if (tableCell.IsTemplate) {
                    for (let j = 0; j < (this.CellProvider.TemplateCells || []).length; j++) {
                        const cell = this.CellProvider.TemplateCells[column];

                        cell.Width = tableCell.Width;

                        if ((cell.Content || []).length === 0) {
                            continue;
                        }

                        for (const content of cell.Content) {
                            content.Width = cell.Width;
                        }
                    }

                    return;
                }

                // Width für die Zellen der Spalte setzen
                for (let j = 0; j < this.CellProvider.Cells.length; j++) {
                    const cell = this.CellProvider.Cells[j][column];

                    cell.Width = tableCell.Width;

                    if ((cell.Content || []).length === 0) {
                        continue;
                    }

                    for (const content of cell.Content) {
                        content.Width = cell.Width;
                    }
                }

                return;
            }

            if (tableCell.IsTemplate) {
                this.CellProvider.TemplateCells[column] = tableCell;
            } else {
                this.CellProvider.Cells[row][column] = tableCell;
            }
        };

        /**
         * Gibt die Instanz einer Zelle zurück.
         * @function
         * @param {TableCell} tableCell
         * @returns {?TableCell} Zelle einer Tabelle
         */
        TableComponent.prototype.GetTableCell = function(tableCell) {
            if (!tableCell) {
                return null;
            }

            const row = tableCell.Row;
            const column = tableCell.Column;

            if (tableCell.IsHeader) {
                return this.HeaderCellProvider.Cells[row || 0][column];
            }

            return tableCell.IsTemplate ? this.CellProvider.TemplateCells[column] : this.CellProvider.Cells[row][column];
        };

        /**
         * Sucht die TableCell, die ein Component enthält
         * @param {string} componentIdentifier
         * @returns {TableCell}
         */
        TableComponent.prototype.FindTableCellOfComponent = function(componentIdentifier) {
            const cells = Object.values(this.TableCellsMap || {});

            for (const cell of cells) {
                for (const component of cell.Content || []) {
                    if (component.OID !== componentIdentifier) {
                        continue;
                    }

                    return cell;
                }
            }
        }

        TableComponent.prototype.RenderOnPage = function () {
            this.TableComponentsMap = {};
            this.TableCellsMap = {};
            this.ColumnSizes = [];

            global.Model.BaseComponent.prototype.RenderOnPage.call(this, this.Page, global.Model.Enums.SectionModificationArea.Page);

            if (!!this.GroupOID) {
                this.$node.attr('data-group-oid', this.GroupOID);
            }

            const components = Object.values(this.TableComponentsMap);
            const $page = $(this.Page.PageSelector);

            for (const component of components) {
                const $node = $page.find(`.table-cell-component[data-identifier="${component.OID}"]`);
                component.SetNode($node);
            }

            fixImageHeightOfCatalogPictureComponents.call(this);
            updateTableDimensions.call(this, this.Page); // Größe der Komponente an Tabelle anpassen
            insertResizers.call(this);
            bindEvents.call(this);

            for (const cell of this.HeaderCellProvider.Cells[0]) {
                this.ColumnSizes.push(cell.Width || 0);
            }

            const $tableSettingsButton = this.$node.find('.table-settings-button');
            $tableSettingsButton.css({
                left: -$tableSettingsButton.width()
            });
        };

        function bindEvents() {
            const $page = $(this.Page.PageSelector);

            // settings button
            const $tableSettingsButton = this.$node.find('.table-settings-button');
            $tableSettingsButton.off('click.selectNodeButton');
            $tableSettingsButton.on('click.selectNodeButton', (event) => {
                $page.find('.table-component').removeClass('active');
                this.OnComponentClick(event);
            });

            // components
            const components = Object.values(this.TableComponentsMap);
            for (const component of components) {
                const $node = component.$node;

                $node.off('click.selectNode');
                $node.on('click.selectNode', (event) => {
                    $page.find('.table-component').removeClass('active');
                    component.OnComponentClick(event);
                    this.$node.addClass('active');
                });
            }
        }

        /**
         * @function
         * @param {string} identifier - Komponente OID einer Zelle
         * @returns {?BaseComponent} Gibt die Komponente einer Zelle zurück.
         */
        TableComponent.prototype.GetSelectedCellComponent = function(identifier) {
            return this.TableComponentsMap[identifier];
        };

        TableComponent.prototype.RemoveHelperInformation = function () {
            delete this.TableComponentsMap;
            delete this.TableCellsMap;
            delete this.ColumnSizes;

            global.Model.BaseComponent.prototype.RemoveHelperInformation.call(this);

            for (let i = 0; i < this.HeaderCellProvider.Cells.length; i++) {
                let row = this.HeaderCellProvider.Cells[i];

                for (let j = 0; j < row.length; j++) {
                    let cell = row[j];

                    for (let k = 0; k < cell.Content.length; k++) {
                        global.Model.BaseComponent.prototype.RemoveHelperInformation.call(cell.Content[k]);
                    }
                }
            }

            for (let i = 0; i < (this.CellProvider.Cells || []).length; i++) {
                let row = this.CellProvider.Cells[i];

                for (let j = 0; j < row.length; j++) {
                    let cell = row[j];

                    for (let k = 0; k < cell.Content.length; k++) {
                        global.Model.BaseComponent.prototype.RemoveHelperInformation.call(cell.Content[k]);
                    }
                }
            }

            for (let i = 0; i < (this.CellProvider.TemplateCells || []).length; i++) {
                delete this.CellProvider.TemplateCells[i].Row;

                for (let k = 0; k < this.CellProvider.TemplateCells[i].Content.length; k++) {
                    global.Model.BaseComponent.prototype.RemoveHelperInformation.call(this.CellProvider.TemplateCells[i].Content[k]);
                }
            }
        };

        /**
         * Führt Aktionen nach dem Resizen der Tabelle aus
         * @function
         * @param {Page} page - Seite des PDFs
         */
        TableComponent.prototype.OnAfterTableResized = function (page) {
            this.ColumnSizes = [];
            const components = Object.values(this.TableComponentsMap);

            fixImageHeightOfCatalogPictureComponents.call(this);
            updateTableDimensions.call(this, page);
            updateResizers.call(this);

            for (const component of components) {
                const $node = component.$node;

                if (!$node || $node.length <= 0) {
                    continue;
                }

                // weil jQuery für Elemente in einer Tabelle falsche Maße liefert, wird hier mit dem native DOM gearbeitet
                const nodeElement = $node[0];
                const cellElement = $node.parent()[0];

                const cellWidth = cellElement.getBoundingClientRect().width;
                const cellHeight = cellElement.getBoundingClientRect().height;

                nodeElement.style.width = `${cellWidth}px`;

                let cell = this.TableCellsMap[cellElement.dataset.cell];
                cell = this.GetTableCell(cell);

                const dimensions = {
                    height: (cellHeight / page.Height) * 100,
                    width: (cellWidth / page.Width) * 100
                };

                if (cell) {
                    cell.Width = dimensions.width;
                    cell.Height = dimensions.height;
                }

                component.SetDimensions(dimensions.height, dimensions.width);
                this.SetTableCell(cell, cell.IsHeader);
            }

            for (const cell of this.HeaderCellProvider.Cells[0]) {
                this.ColumnSizes.push(cell.Width || 0);
            }

            const $tableSettingsButton = this.$node.find('.table-settings-button');
            $tableSettingsButton.css({
                left: -$tableSettingsButton.width()
            });
        };


        /**
         * Fügt Resizer zwischen die Zeilen und zwischen die Spalten der Tabelle ein.
         * Resizer werden gebraucht, weil InteractJS (speziell: Edges) sonst nicht die gewünschten Resize-Bereiche in Tabellen abbilden kann.
         */
        function insertResizers() {
            // weil jQuery für Elemente innerhalb der Tabelle falsche Maße liefert, wird dort mit dem native DOM gearbeitet

            const $table = this.$node.find('table');
            const $tableHeaders = $table.find('th');
            const $tableRows = $table.find('tr');

            $tableHeaders.each((index, headerElement) => {
                if (index === $tableHeaders.length - 1) {
                    return;
                }

                const columnResizerElement = document.createElement('div');
                columnResizerElement.classList.add('col-resizer');

                headerElement.append(columnResizerElement);

                const left = headerElement.offsetLeft + headerElement.offsetWidth - (columnResizerElement.offsetWidth / 2);

                columnResizerElement.style.top = `${headerElement.offsetTop}px`;
                columnResizerElement.style.left = `${left}px`;
                columnResizerElement.style.height = `${$table.height()}px`;
            });

            $tableRows.each((index, rowElement) => {
                if (index === $tableRows.length - 1) {
                    return;
                }

                const firstTableCellElement = rowElement.querySelector('th, td');
                if (!firstTableCellElement) {
                    return;
                }

                const rowResizerElement = document.createElement('div');
                rowResizerElement.classList.add('row-resizer');

                firstTableCellElement.append(rowResizerElement);

                const top = rowElement.offsetTop + rowElement.offsetHeight - (rowResizerElement.offsetHeight / 2);

                rowResizerElement.style.top = `${top}px`;
                rowResizerElement.style.left = `${rowElement.offsetLeft}px`;
                rowResizerElement.style.width = `${rowElement.offsetWidth}px`;
            });
        }

        function updateResizers() {
            // weil jQuery für Elemente innerhalb der Tabelle falsche Maße liefert, wird dort mit dem native DOM gearbeitet

            const $table = this.$node.find('table');
            const $tableHeaders = $table.find('th');
            const $tableRows = $table.find('tr');

            $tableHeaders.each((index, headerElement) => {
                if (index === $tableHeaders.length - 1) {
                    return;
                }

                const resizerElement = headerElement.querySelector('.col-resizer');

                const left = headerElement.offsetLeft + headerElement.offsetWidth - (resizerElement.offsetWidth / 2);

                resizerElement.style.top = `${headerElement.offsetTop}px`;
                resizerElement.style.left = `${left}px`;
                resizerElement.style.height = `${$table.height()}px`;
            });

            $tableRows.each((index, rowElement) => {
                if (index === $tableRows.length - 1) {
                    return;
                }

                const rowResizerElement = rowElement.querySelector('.row-resizer');

                const top = rowElement.offsetTop + rowElement.offsetHeight - (rowResizerElement.offsetHeight / 2);

                rowResizerElement.style.top = `${top}px`;
                rowResizerElement.style.left = `${rowElement.offsetLeft}px`;
                rowResizerElement.style.width = `${rowElement.offsetWidth}px`;
            });
        }

        /**
         * Passt die Tabellenbreite an den Tabelleninhalt an.
         * @param {Page} page - Seite des PDFs
         */
        function updateTableDimensions(page) {
            const $tableHeaders = this.$node.find('table th');
            const $tableRows = this.$node.find('table tr');

            let width = 0;
            let height = 0;

            if ($tableHeaders && $tableHeaders.length > 0) {
                $tableHeaders.each((index, headerElement) => {
                    width += headerElement.getBoundingClientRect().width;
                });

                const firstHeaderElement = $tableHeaders[0];
                const firstHeaderStyle = getComputedStyle(firstHeaderElement);
                width += 0.5 * (parseFloat(firstHeaderStyle.borderLeftWidth) || 0);

                const lastHeaderElement = $tableHeaders[$tableHeaders.length - 1];
                const lastHeaderStyle = getComputedStyle(lastHeaderElement);
                width += 0.5 * (parseFloat(lastHeaderStyle.borderRightWidth) || 0);
            }

            if ($tableRows && $tableRows.length > 0) {
                $tableRows.each((index, rowElement) => {
                    height += rowElement.getBoundingClientRect().height;
                });

                const firstRowElement = $tableRows[0];
                const firstRowStyle = getComputedStyle(firstRowElement);
                height += 0.5 * (parseFloat(firstRowStyle.borderTopWidth) || 0);

                const lastRowElement = $tableRows[$tableRows.length - 1];
                const lastRowStyle = getComputedStyle(lastRowElement);
                height += 0.5 * (parseFloat(lastRowStyle.borderBottomWidth) || 0);
            }

            this.$node.width(width);
            this.$node.height(height);

            const dimensions = {
                width: (width / page.Width) * 100,
                height: (height / page.Height) * 100,
            };

            this.SetDimensions(dimensions.height, dimensions.width);
        }

        /**
         * Setzt die Höhe von HTMLImageElementen in CatalogPictureComponents nach der Höhe der Tabellenzeile.
         *
         * Erklärung: da HTMLImageElement hier die korrekte (max-/)height nicht inferieren (`max-height: 100%`) können,
         * da dazu an den ParentElementen (Dom-Elemente der CatalogPictureComponents) konkrete Höhenangaben statt `100%` existieren müssten,
         * muss die Höhe der HTMLImageElemente manuell festgelegt werden.
         *
         * Fix für Chrome
         */
        function fixImageHeightOfCatalogPictureComponents() {
            const components = Object.values(this.TableComponentsMap);

            for (const component of components) {
                if (!(component instanceof global.Model.CataloguePictureComponent)) {
                    continue;
                }

                const componentElement = component.$node[0];
                const imageElement = componentElement.querySelector('img');

                let currentElement = imageElement.parentElement;
                let heightOffset = 0;
                while (!(currentElement instanceof HTMLTableRowElement)) {
                    const style = getComputedStyle(currentElement);
                    const borderCorrectionFactor =
                        (currentElement instanceof HTMLTableRowElement && style.borderCollapse === 'collapse')
                        || (currentElement instanceof HTMLTableCellElement && style.borderCollapse === 'collapse')
                            ? 0.5
                            : 1;

                    heightOffset += borderCorrectionFactor * ((parseFloat(style.borderTop) || 0) + (parseFloat(style.borderBottom) || 0));
                    heightOffset += (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
                    heightOffset += (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);

                    currentElement = currentElement.parentElement;
                }

                const tableRowElement = currentElement;
                const rowHeight = parseFloat(tableRowElement.style.height) || 0;
                imageElement.style.maxHeight = `${rowHeight - heightOffset}px`;
            }
        }

        /**
         * @returns {TableCell}
         * @class
         */
        TableComponent.prototype.TableCell = (function() {
            /**
             * @constructor
             */
            function TableCell(tableCellSettings) {
                this.RowSpan = tableCellSettings.RowSpan || 1;

                this.Column = tableCellSettings.Column;
                this.ColumnSpan = tableCellSettings.ColumnSpan || 1;

                this.Width = tableCellSettings.Width || 2;
                this.Height = tableCellSettings.Height || 2;

                this.BackgroundColor = tableCellSettings.BackgroundColor || (tableCellSettings.IsHeader ? '#cccccc' : '#ffffff');

                this.Content = tableCellSettings.Content || [];

                for (const contentElement of this.Content) {
                    contentElement.BackgroundColor = this.BackgroundColor;
                }

                this.IsTemplate = !!tableCellSettings.IsTemplate;

                if (!this.IsTemplate) {
                    this.Row = tableCellSettings.Row;
                }

                this.IsHeader = !!tableCellSettings.IsHeader;
                this.OID = uuid();
            }

            TableCell.prototype.constructor = TableCell;

            TableCell.prototype.FitContent = function() {
                let width = 0;
                let height = 0;
                for (const component of this.Content) {
                    width += component.Width;
                    height = Math.max(height, component.Height);
                }

                this.Width = Math.max(this.Width, width);
                this.Height = Math.max(this.Height, height);
            }

            /**
             * @function
             * @param {Page} page - Seite des PDFs
             * @returns {string} Gibt das HTML-Markup für eine Zelle zurück.
             */
            TableCell.prototype.CreateCellMarkup = function(page) {
                const markup = [];

                const dimensions = {
                    height: (this.Height / 100) * page.Height,
                    width: (this.Width / 100) * page.Width
                };

                markup.push(this.IsHeader ? '<th' : '<td');
                markup.push(this.IsHeader ? ` style="width: ${dimensions.width}px"` : '');
                markup.push(` data-cell="${this.OID}"`);
                markup.push(` data-column="${this.Column || 0}"`);
                markup.push(` data-row="${this.Row || 0}"`);
                markup.push(`>`);

                for (let j = 0; j < this.Content.length; j++) {
                    const content = this.Content[j];
                    const html = content.RenderOnPage.call(content, content.Page, content.RenderArea, {
                        Width: this.Width || content.Width,
                        Height: this.Height || content.Height
                    });

                    markup.push(html);
                }

                markup.push(this.IsHeader ? '</th>' : '</td>');

                return markup.join('');
            }

            return TableCell;
        })();

        return TableComponent;
    })();

    /**
     * @augments {BaseComponent}
     * @typedef RectangleComponent
     */
    global.Model.RectangleComponent = (function () {
        /**
         * @param {string|null} title
         * @param {string|null} description
         * @param {ComponentOptions} options
         * @constructor
         */
        function RectangleComponent(title, description, options) {
            this.ComponentSettings = [
                {
                    Label: i18next.t('changeMode.pdfDesigner.settings.layout.label'),
                    Settings: [
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.layout.borderColor.label'),
                            Key: 'StrokeColor',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Color,
                            Default: '#000'
                        },
                    ]
                }
            ];

            this.ZIndex = 2;

            this.CommonSettingsOverrides = {
                Width: {
                    OnAfterChanged: () => {
                        this.SetDimensions(this.Height, this.Width);
                    }
                },
                Height: {
                    OnAfterChanged: () => {
                        this.SetDimensions(this.Height, this.Width);
                    }
                }
            };

            global.Model.BaseComponent.call(
                this,
                global.Model.Enums.ComponentType.Geometry,
                title,
                description,
                'rectangle-empty.svg',
                options
            );

            /**
             * @type {Point[]}
             */
            this.Points = [];

            this.Layout = {
                HorizontalAlignment: global.Model.Enums.HorizontalAlignment.Left,
                VerticalAlignment: global.Model.Enums.VerticalAlignment.Top,
                Rotation: 0,
                Fitmethod: global.Model.Enums.FitMethod.Auto
            };

            /**
             * @type {string}
             */
            this.StrokeColor = '#000000';

            this.ZIndex = 1;
        }

        RectangleComponent.prototype = Object.create(global.Model.BaseComponent.prototype);
        RectangleComponent.prototype.constructor = RectangleComponent;

        RectangleComponent.prototype.CreateDerivedInstance = function (relativeX, relativeY) {
            const $deferred = $.Deferred();

            global.Model.BaseComponent.prototype.CreateDerivedInstance.call(
                this,
                relativeX,
                relativeY
            ).then(component => {
                component.Points = [
                    { X: 0, Y: 0 },
                    { X: this.DefaultDimensions.Width, Y: 0 },
                    { X: this.DefaultDimensions.Width, Y: this.DefaultDimensions.Height },
                    { X: 0, Y: this.DefaultDimensions.Height }
                ];

                $deferred.resolve(component)
            });

            return $deferred.promise();
        };

        /**
         * @param {number} height
         * @param {number} width
         * @return {this}
         */
        RectangleComponent.prototype.SetDimensions = function (height, width) {
            global.Model.BaseComponent.prototype.SetDimensions.call(
                this,
                height,
                width
            );

            this.Points = [
                { X: 0, Y: 0 },
                { X: width, Y: 0 },
                { X: width, Y: height },
                { X: 0, Y: height }
            ];

            return this;
        };

        RectangleComponent.prototype.CreateComponentContent = function () {
            return i18next.t('changeMode.pdfDesigner.components.static.rectangle.label');
        };

        return RectangleComponent;
    })();

    /**
     * @augments {BaseComponent}
     * @typedef LineComponent
     */
    global.Model.LineComponent = (function () {
        /**
         * @param {string|null} title
         * @param {string|null} description
         * @param {ComponentOptions} options
         * @constructor
         */
        function LineComponent(title, description, options) {
            this.ComponentSettings = [
                {
                    Label: i18next.t('changeMode.pdfDesigner.settings.layout.label'),
                    Settings: [
                        {
                            Label: i18next.t('changeMode.pdfDesigner.settings.layout.borderColor.label'),
                            Key: 'StrokeColor',
                            Type: global.Model.Enums.ComponentSettingRepresentation.Color,
                            Default: '#000'
                        },
                    ]
                }
            ];

            this.DisableHeightSetting = true;

            this.CommonSettingsOverrides = {
                Width: {
                    OnAfterChanged: () => {
                        this.SetDimensions(this.Height, this.Width);
                    }
                },
                Height: {
                    OnAfterChanged: () => {
                        this.SetDimensions(this.Height, this.Width);
                    }
                }
            };

            global.Model.BaseComponent.call(
                this,
                global.Model.Enums.ComponentType.Geometry,
                title,
                description,
                'line.svg',
                options
            );

            /**
             * @type {Point[]}
             */
            this.Points = [];

            this.Layout = {
                HorizontalAlignment: global.Model.Enums.HorizontalAlignment.Left,
                VerticalAlignment: global.Model.Enums.VerticalAlignment.Top,
                Rotation: 0,
                Fitmethod: global.Model.Enums.FitMethod.Auto
            };

            this.DefaultDimensions.Height = 0;

            /**
             * @type {string}
             */
            this.StrokeColor = '#000000';

            this.ZIndex = 2;
        }

        LineComponent.prototype = Object.create(global.Model.BaseComponent.prototype);
        LineComponent.prototype.constructor = LineComponent;

        LineComponent.prototype.CreateDerivedInstance = function (relativeX, relativeY) {
            const $deferred = $.Deferred();

            global.Model.BaseComponent.prototype.CreateDerivedInstance.call(
                this,
                relativeX,
                relativeY
            ).then(component => {
                component.Points = [
                    { X: 0, Y: 0 },
                    { X: this.DefaultDimensions.Width, Y: 0 }
                ];

                $deferred.resolve(component)
            });

            return $deferred.promise();
        };

        /**
         * @param {number} height Hat auf diese Komponente keine Auswirkungen!
         * @param {number} width
         * @return {this}
         */
        LineComponent.prototype.SetDimensions = function (height, width) {
            global.Model.BaseComponent.prototype.SetDimensions.call(
                this,
                0,
                width
            );

            this.Points = [
                { X: 0, Y: 0 },
                { X: width, Y: 0 }
            ];

            return this;
        };

        LineComponent.prototype.CreateComponentContent = function () {
            return '';
        };

        return LineComponent;
    })();
})(Modifications.Popups.PdfDesigner || (Modifications.Popups.PdfDesigner = {}));